import {
  LockOutlined,
  People,
  MonetizationOn,
  Assessment,
  PersonOutline,
  ContactMail,
  Home,
  Source,
  Work,
} from "@mui/icons-material";

export const ROLES_PERMISSIONS = [
  {
    category: "Lead Management",
    icon: <People color="primary" />,
    permissions: [
      {
        label: "Add Lead",
        name: "addLead",
        description: "Create new lead records",
      },
      {
        label: "Update Lead",
        name: "updateLead",
        description: "Modify existing leads",
      },
      {
        label: " Leads Pool",
        name: "viewpool",
        description: "Access Leads Pool information",
      },
      {
        label: "Assign Lead",
        name: "assignlead",
        description: "Delegate leads to team members",
      },
      {
        label: "View Lead",
        name: "viewlead",
        description: "Access lead information",
      },
      {
        label: "View Agency Leads",
        name: "viewalllead",
        description: "Access Agency lead information",
      },
      {
        label: "Upload Leads",
        name: "uploadleads",
        description: "Bulk import leads from files",
      },
    ],
  },
  {
    category: "Property Management",
    icon: <LockOutlined color="primary" />,
    permissions: [
      {
        label: "Add Property",
        name: "addProperty",
        description: "Create new property listings",
      },
      {
        label: "View Property",
        name: "viewProperty",
        description: "Access property information",
      },
      {
        label: "Update Property",
        name: "updateProperty",
        description: "Modify existing properties",
      },
      {
        label: "View Property Location",
        name: "propertylocation",
        description: "Access to Property Location",
      },
      {
        label: "Owner Contact No",
        name: "ownercontact",
        description: "Access to Property Owner Contact No",
      },
    ],
  },
  
  {
    category: "Task Management",
    icon: <Assessment color="primary" />,
    permissions: [
      {
        label: "Assign Task",
        name: "assigntask",
        description: "Delegate tasks to team members",
      },
      {
        label: "View All Tasks",
        name: "viewalltask",
        description: "Access complete task list",
      },
    ],
  },
  {
    category: "Data Access",
    icon: <Assessment color="primary" />,
    permissions: [
      {
        label: "View Contacts",
        name: "viewContacts",
        description: "Access contact information",
      },
      {
        label: "View Accounts",
        name: "viewAccounts",
        description: "View financial accounts",
      },
    ],
  },
  {
    category: "Staff Management",
    icon: <People color="primary" />,
    permissions: [
      {
        label: "Add Staff",
        name: "addstaff",
        description: "Create new user accounts",
      },
    ],
  },
  {
    category: "Financial",
    icon: <MonetizationOn color="success" />,
    permissions: [
      {
        label: "Generate Voucher",
        name: "genVoucher",
        description: "Create payment vouchers",
      },
    ],
  },
];




export const LEAD_PERMISSIONS = [
  {
    category: "Lead Information",
    icon: <PersonOutline color="primary" />,
    fields: [
      {
        label: "First Name",
        name: "firstname",
        description: "Access to lead's first name",
      },
      {
        label: "Last Name",
        name: "lastname",
        description: "Access to lead's last name",
      },
      {
        label: "History",
        name: "history",
        description: "Access to lead history",
      },
      {
        label: "Property Data",
        name: "propertydata",
        description: "Access to property data",
      },
      {
        label: "Description",
        name: "description",
        description: "Access to lead description",
      },
      {
        label: "Lead Type",
        name: "leadtype",
        description: "Access to lead type information",
      },
      {
        label: "Lead Time",
        name: "leadTime",
        description: "Access to lead time information",
      },
      {
        label: "Last Updated Date",
        name: "lastUpdatedDate",
        description: "Access to last updated date",
      },
      {
        label: "Lead Tag",
        name: "leadTag",
        description: "Access to lead tags",
      },
      {
        label: "Lead Status",
        name: "leadStatus",
        description: "Access to lead status",
      },
    ],
  },

  {
    category: "Property Information",
    icon: <Home color="primary" />,
    fields: [
      {
        label: "Lead Serial No",
        name: "leadSerialNo",
        description: "Access to lead serial number",
      },
      {
        label: "Property Ref No",
        name: "propertyRefNo",
        description: "Access to property reference number",
      },
      {
        label: "Society Name",
        name: "societyName",
        description: "Access to society name",
      },
      {
        label: "File No",
        name: "fileNo",
        description: "Access to file number",
      },
      {
        label: "Block",
        name: "block",
        description: "Access to block information",
      },
      {
        label: "Plot No",
        name: "plotNo",
        description: "Access to plot number",
      },
      {
        label: "Plot Size",
        name: "plotSize",
        description: "Access to plot size information",
      },
      {
        label: "Property Type",
        name: "propertyType",
        description: "Access to property type",
      },
      {
        label: "Additional No",
        name: "additionalNo",
        description: "Access to additional numbers",
      },
    ],
  },
  {
    category: "Contact Information",
    icon: <ContactMail color="primary" />,
    fields: [
      {
        label: "Email",
        name: "email",
        description: "Access to email address",
      },
      {
        label: "Membership ID",
        name: "membershipId",
        description: "Access to membership ID",
      },
      {
        label: "Type",
        name: "type",
        description: "Access to contact type",
      },
      {
        label: "WhatsApp No",
        name: "whatsappNo",
        description: "Access to WhatsApp number",
      },
      {
        label: "More Info",
        name: "moreinfo",
        description: "Access to additional information",
      },
    ],
  },
  {
    category: "Professional Information",
    icon: <Work color="primary" />,
    fields: [
      {
        label: "Company Name",
        name: "companyName",
        description: "Access to company name",
      },
      {
        label: "Designation",
        name: "designation",
        description: "Access to professional designation",
      },
      {
        label: "Budget",
        name: "budget",
        description: "Access to budget information",
      },
      {
        label: "Location",
        name: "location",
        description: "Access to location information",
      },
    ],
  },
  {
    category: "Source Information",
    icon: <Source color="primary" />,
    fields: [
      {
        label: "Source",
        name: "source",
        description: "Access to lead source information",
      },
      {
        label: "Medium",
        name: "medium",
        description: "Access to lead medium information",
      },
      {
        label: "Priority",
        name: "priority",
        description: "Access to lead priority information",
      },
    ],
  },
  
 
];